export async function supportsImageType(type: string): Promise<boolean> {
    // only Safari does not support ImageDecoder but support heic/heic types
    if (!globalThis?.ImageDecoder && type.startsWith('image')) {
        return true;
    }
    if (globalThis.ImageDecoder?.isTypeSupported) {
        try {
            const supported = await globalThis.ImageDecoder.isTypeSupported(type);
            return !!supported;
        } catch {
            return false;
        }
    }
    return false;
}

const isHeif = (fileType) => fileType === 'image/heif';
const isHeic = (fileType) => fileType === 'image/heic';

export function heifFormatsValidatorMessage(fileType) {
    const typeName = fileType?.split('/')?.[1];
    return typeName && (isHeif(fileType) || isHeic(fileType))
        ? `For ${typeName.toUpperCase()} images please use Safari browser.`
        : '';
}
